import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  field: {
    input: {
      '&:user-invalid': {
        // borderColor: theme.palette.error.main
        color: theme.palette.error.main
      }
    },
  },
  loginButton: {
    fontWeight: theme.typography.fontWeightSemibold,
    fontSize: '0.875rem',
  },
}));

export default useStyles;